import { Component, OnDestroy } from '@angular/core';
import { Observable, Subject } from "rxjs";
import { FormControl, FormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { takeUntil } from "rxjs/operators";
import { Tag } from '../../../../../shared/interfaces/tag';
import { ConsoleLoggerService } from '../../../../../core/services/console-logger.service';
import { nav_path } from 'src/app/app-routing.module';
import { FirestoreService } from '../../../../../shared/services/firestore.service';

@Component({
  selector: 'anon-edit-tag',
  templateUrl: './edit-tag.component.html',
  styleUrls: ['./edit-tag.component.scss']
})
export class EditTagComponent implements OnDestroy {
  private unsub$: Subject<any> = new Subject<any>();
  tag!: Tag;
  error: any;
  editTagForm = new FormGroup({
    name: new FormControl('', Validators.required),
    description: new FormControl(''),
    slug: new FormControl('', Validators.required),
    featured: new FormControl(false),
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private db: FirestoreService,
    private cLog: ConsoleLoggerService
  ) {
    this.route.params.pipe(takeUntil(this.unsub$))
      .subscribe(routeParams => {
        const tag_slug = routeParams['tag_slug'];
        (this.db.doc$(`tags/${tag_slug}`) as Observable<Tag>)
          .pipe(takeUntil(this.unsub$))
          .subscribe(
            (tag: Tag) => {
            if (tag?.created && tag?.slug) this.setTag(tag);
            else this.error = {message: `Tag not found: ${tag_slug}`};
            },
            error => this.cLog.error('error getting tag', tag_slug, error)
          )
      });
  }
  get name() { return this.editTagForm.get('name'); }
  get description() { return this.editTagForm.get('description'); }
  get slug() { return this.editTagForm.get('slug'); }
  get featured() { return this.editTagForm.get('featured'); }

  setTag(tag: Tag) {
    this.tag = tag;
    this.editTagForm = new FormGroup({
      name: new UntypedFormControl(tag.name, Validators.required),
      description: new UntypedFormControl(tag.description),
      slug: new UntypedFormControl(tag.slug, Validators.required),
      featured: new UntypedFormControl(tag.featured)
    });
    this.slug?.disable();
  }

  saveTag() {
    this.slug?.enable();
    const tag = this.editTagForm?.value;
    if (
      this.tag.name != tag.name
      || this.tag.description != tag.description
      || this.tag.featured != tag.featured
    ) this.db.update(`tags/${this.tag.slug}`, tag)
      .then(() => {
        this.cLog.info(`successfully updated tag: '${this.tag.slug}'`);
        this.router.navigate([nav_path.adminTags]);
      });
  }

  public deleteTag() {
    this.db.delete(`tags/${this.tag.slug}`)
      .then(() => this.router.navigate([nav_path.adminTags]))
  }

  ngOnDestroy() { this.unsub$.next(undefined); this.unsub$.complete(); }
}
